const updateSummaryChartData = (state, payload) => {
  state.summaryChartData = payload;
};

const updateSummaryMaxValues = (state, payload) => {
  const {
    maxPercentage, maxDecimalBase, maxDecimalComp, maxDecimalOverall,
  } = payload;
  state.summaryPageMaxPercent = maxPercentage;
  state.summaryPageMaxDecimalBase = maxDecimalBase;
  state.summaryPageMaxDecimalComp = maxDecimalComp;
  state.summaryPageMaxDecimalOverall = maxDecimalOverall;
};

export default {
  updateSummaryChartData,
  updateSummaryMaxValues,
};
